import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StateService } from 'src/app/core/services/state.service';
import { switchMap, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/core/services/api.service';

const initialState = {
    userLogin: {
        id: '',
        nama: '',
        email: '',
        user_profile: '',
    },
};

@Injectable({
    providedIn: 'root'
})

export class AuthService extends StateService<any> {
    userLogin: Observable<any> = this.select(state => state.userLogin);

    constructor(private apiService: ApiService) {
        super(initialState);
    }

    /**
     * Check if user has access to feature
     */
    checkAccess(access: String) {
        if (access == 'none') {
            return true;
        }
        let userLogin: any;
        this.getProfile().subscribe((user: any) => (userLogin = user));
        if (userLogin.id == '') {
            return false;
        }
        const permission = access.split('|');
        for (const val of permission) {
            const exp = val.split('.');
            const feature = exp?.[0] ?? '-';
            const activity = exp?.[1] ?? '-';

            if (userLogin?.access?.[feature]?.[activity] && userLogin.access[feature][activity] == true) {
                return true;
            }
        }

        return false;
    }

    /**
     * Request login
     */
    login(email, password) {
        return this.apiService.DataPost('/v1/auth/login-customer', {
            email: email,
            password: password
        });
    }

    /**
     * Ambil token CSRF dari server dan simpan di localStorage
     */
    saveCsrf() {
        this.apiService.DataGet('/v1/auth/csrf').subscribe((res: any) => {
            return new Promise((resolve, reject) => {
                localStorage.setItem('csrf', res.data);
                resolve(true);
            });
        });
    }

    /**
     * Ambil token CSRF dari localStorage
     */
    getCsrf() {
        const token = localStorage.getItem('csrf');
        if (token) {
            return token;
        }

        return '';
    }

    /**
     * Logout
     */
    logout() {
        this.removeToken();
        this.setState({
            userLogin: {
                id: '',
                nama: '',
                email: '',
                user_profile: '',
            },
        })
    }

    requestLogout() {
        return this.apiService.DataPost('/v1/account/logout', {});
    }

    /**
     * Ambil profile user yang login dari state management
     */
    getProfile() {
        return this.select(state => state.userLogin);
    }

    /**
     * Ambil user yang login ke server
     * dan simpan di RxJS
     */
    saveUserLogin() {
        return this.apiService.DataGet('/v1/auth/profile').subscribe((res: any) => {

            this.setState({ userLogin: res.data });
        });
    }

    /**
    * Simpan token user ke localstorage
    */
    saveToken(payload: any) {
        return new Promise((resolve, reject) => {
            localStorage.setItem('user', payload);
            resolve(true);
        });
    }

    /**
     * Hapus user dari local Storage
     */
    removeToken() {
        return new Promise((resolve, reject) => {
            localStorage.removeItem('user');
            resolve(true);
        });
    }

    /**
     * Ambil token user dari localstorage
     */
    getToken() {
        const token = localStorage.getItem('user');
        if (token) {
            return token;
        }

        return '';
    }

    getNotification(arrParameter = {}) {
        return this.apiService.DataGet('/v1/notifikasi', arrParameter);
    }
    readNotif(arrParameter = {}) {
        return this.apiService.DataPut('/v1/notifikasi/marked', arrParameter);
    }
    readAllNotif(arrParameter = {}) {
        return this.apiService.DataPut('/v1/notifikasi/markMultiple', arrParameter);
    }


    checkPermissionAccess(accessList: string | string[]): Observable<boolean> {
        const permissions = Array.isArray(accessList) ? accessList : [accessList];

        if (this.state?.userLogin?.id != '') {
            return of(permissions.some(access => this.checkAccess(access)));
        }

        return this.saveUserLoginCheckPermission().pipe(
            switchMap(() => of(permissions.some(access => this.checkAccess(access))))
        );
    }

    saveUserLoginCheckPermission(): Observable<void> {
        return this.apiService.DataGet('/v1/auth/profile').pipe(
            tap((res: any) => this.setState({ userLogin: res.data }))
        );
    }




    sendMailAgain(payload) {
        return this.apiService.DataPost('/v1/verify-account/sendMailAgain', payload);
    }
    checkOTP(payload) {
        return this.apiService.DataPost('/v1/verify-account/checkOTP', payload);
    }
    updateGantiPassword(payload) {
        return this.apiService.DataPost('/v1/verify-account/updateGantiPass', payload);
    }
    checkCountdownOTP(arrParameter = {}) {
        return this.apiService.DataGet('/v1/verify-account/checkCountdownOTP', arrParameter);
    }




    sendMailForgetPassLupaPassword(payload) {
        return this.apiService.DataPost('/v1/lupa-password/sendMailForgetPass', payload);
    }
    sendMailAgainLupaPassword(payload) {
        return this.apiService.DataPost('/v1/lupa-password/sendMailAgain', payload);
    }
    checkOTPLupaPassword(payload) {
        return this.apiService.DataPost('/v1/lupa-password/checkOTP', payload);
    }
    updateGantiPasswordLupaPassword(payload) {
        return this.apiService.DataPost('/v1/lupa-password/updateGantiPass', payload);
    }
    checkCountdownOTPLupaPassword(arrParameter = {}) {
        return this.apiService.DataGet('/v1/lupa-password/checkCountdownOTP', arrParameter);
    }


    register(payload: {
        name: string,
        email: string,
        password: string,
        password_confirmation: string,
    }) {
        return this.apiService.DataPost('/v1/users/register', payload);
    }
}
